/// <amd-module name="Build/Run/Components/CoverageResultsLink" />
import * as React from "react";

import * as Resources from "Build/Run/Resources";
import { IRunDetailsService } from "Build/Run/RunDetailsService.types";
import { CodeCoverageSummary, TestResults } from "Build/Run/RunExternalService";

//import { TestReportDataParser } from "Test/common-util/Common.Utils";

import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { format } from "VSS/Core/Util/String";
import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { Icon } from "VSSUI/Icon";
import { Observer } from "VSSUI/Observer";

const c_coverageGetStartedDoc = "https://docs.microsoft.com/en-us/azure/devops/pipelines/test/review-code-coverage-results?view=azure-devops";

interface ICoverageResultsProps {
    coverageTabUrl: string;
    linkDescribedBy?: string;
}

export class CoverageResultsLink extends VssComponent<ICoverageResultsProps> {
    private _coverageResult: IReadonlyObservableValue<CodeCoverageSummary>;
    private _testsRunResult: IReadonlyObservableValue<TestResults>;

    constructor(props: ICoverageResultsProps, context: IVssComponentContext) {
        super(props, context);

        const runDetailsService = this.context.pageContext.getService<IRunDetailsService>("IRunDetailsService");
        this._coverageResult = runDetailsService.codeCoverageResults;
        this._testsRunResult = runDetailsService.testRunResults;
    }

    public render() {
        return <Observer coverageResult={this._coverageResult} testResults={this._testsRunResult}>
            {
                (observerProps: { coverageResult: CodeCoverageSummary, testResults: TestResults }) => {
                    if (observerProps.testResults.testsCount < 1) {
                        return (
                            <span className="empty-summary-row"> </span>
                        )
                    }

                    if (observerProps.coverageResult && observerProps.coverageResult.coverage) {
                        let text = format(Resources.CoverageFormat, observerProps.coverageResult.coverage);
                        let link = this.props.coverageTabUrl;
                        let icon: JSX.Element = <Icon iconName="StackedBarChart" className="icon-margin" />;
                        let className = "text-ellipsis flex-row flex-baseline";
                        let subtle = true;

                        return (
                            <FPSLink ariaDescribedBy={this.props.linkDescribedBy} href={link} className={className} subtle={subtle}>
                                    <span className="text-ellipsis">
                                        {icon}
                                        {text}
                                    </span>
                                </FPSLink>
                        );
                    }
                    return (
                        <FPSLink ariaDescribedBy={this.props.linkDescribedBy} href={c_coverageGetStartedDoc} className="text-ellipsis flex-row flex-baseline pipeline-link">
                            <span className="text-ellipsis">
                                {Resources.SetupCoverage}
                            </span>
                        </FPSLink>
                    );
                }
            }
        </Observer>;
    }
}
